// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface DashboardMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}

const dashboard: DashboardMenuProps[] = [
    {
        id: 'dashboard',
        title: <FormattedMessage id="dashboard" />,
        type: 'group',
        children: [
            {
                id: 'mainDashboard',
                title: <FormattedMessage id="main" />,
                type: 'item',
                url: 'dashboard',
                icon: icons.IconDashboard,
                breadcrumbs: false
            }
        ]
    }
];

export default dashboard;
